function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { changeEmailErrorMessages, ViewType } from "../ChangeEmailAddressTypes";
import { Controller, useForm } from 'react-hook-form';
import { Button, TextField, Typography, useIsMounted } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import commonStyles from "../ChangeEmailAddress.module.scss";
import { emailValidation } from 'validators';
import { handleRequest } from "../../../infra/utils";
import { useStoreActions } from "../../../store/store-context";
import { ServerError } from "../../../infra/ErrorResponse";
const SetUpNewEmail = _ref => {
  let {
    onClose,
    handleSetView,
    handleSetNewEmail
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useIsMounted();
  const {
    control,
    formState,
    handleSubmit,
    setError
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      newEmail: ''
    }
  });
  const handleSetUpNewEmail = async newEmail => {
    handleSetView(ViewType.VerifyNewEmail);
    handleSetNewEmail(newEmail);
    setIsLoading(false);
    return;
  };
  const handleError = error => {
    if (error.hasServerError(ServerError.EmailAlreadyRegistered)) {
      setError('newEmail', {
        message: changeEmailErrorMessages.emailAlreadyRegistered
      });
      return;
    }
    if (error.isTooManyAttemptsError()) {
      handleSetView(ViewType.TooManyAttempts);
      return;
    }
    setError('newEmail', {
      message: changeEmailErrorMessages.somethingWentWrong
    });
  };
  const sendNewEmail = async _ref2 => {
    let {
      newEmail
    } = _ref2;
    setIsLoading(true);
    const changeEmailResult = await handleRequest(api.user.changeUserEmail({
      email: newEmail
    }));
    if (changeEmailResult.success) {
      await handleSetUpNewEmail(newEmail);
    } else {
      handleError(changeEmailResult.error);
    }
    if (isMounted()) {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "set-up-new-email-address-view"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(sendNewEmail)
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    "data-testid": "set-up-new-email-info-text"
  }, "To verify your new email address, we\u2019ll send you a confirmation email ", /*#__PURE__*/React.createElement("br", null), " containing a one-time code."), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "newEmail",
    rules: emailValidation(undefined, {
      required: true
    }),
    render: p => /*#__PURE__*/React.createElement(TextField, _extends({
      width: 360,
      "data-testid": "set-up-new-email-address",
      type: "email",
      label: "New email address"
    }, connectControllerToTextField(p)))
  })), /*#__PURE__*/React.createElement("div", {
    className: commonStyles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    skin: "primaryOutlineOpaque",
    "data-testid": "set-up-new-email-cancel-button"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    "data-testid": "set-up-new-email-send-code-button",
    disabled: !formState.isValid,
    loading: isLoading
  }, "Send code"))));
};
export default SetUpNewEmail;